
import initParticipationSlider from './init-participation-slider';
import initFaqSlider from './init-faq-slider';
import initDiplomSlider from './init-diplom-slider.js';
import initPartnersSlider from './init-partners-slider.js';
import initCasesSlider from './init-cases-slider.js';
import initNewsSlider from './init-news-slider.js';
import initTeachersSlider from './init-teachers-slider.js';
import initCooperationSlider from './init-cooperation-slider.js';
import initStoriesSlider from './init-stories-slider.js';
import initHrReviewsSlider from './init-hr-reviews-slider.js';
import initTeamsSlider from './init-team-slider.js';
import initReviewsPageSlider from './init-reviewsPage-slider.js';
import initJobSeekerSliders from './init-job-seeker-sliders.js';
import initDissmisalriskSlider from './init-dissmisalrisk-slider.js';
import initCommentsSlider from './init-comments-slider.js';
import initReviewsSlider from './init-reviews-slider.js';

const sliders = () => {
    initParticipationSlider();
    initFaqSlider();
    initDiplomSlider();
    initPartnersSlider();
    initCasesSlider();
    initNewsSlider();
    initTeachersSlider();
    initCooperationSlider();
    initStoriesSlider();
    initHrReviewsSlider();
    initTeamsSlider();
    initReviewsPageSlider();
    initJobSeekerSliders();
    initDissmisalriskSlider();
    initCommentsSlider();
    initReviewsSlider();
}

export default sliders;